import React, { useCallback, useEffect, useState } from "react";
import bigInt from "big-integer";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  DialogContent,
  Dialog,
  Slide,
  Typography,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { toFixed } from "../../../constants/constants";
import OutlineButton from "../../stake/components/OutlineButton";
import Button from "../../stake/components/Button";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "34px !important",
    padding: "32px 48px 24px 48px",
    position: "relative",
  },
  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  modalRoot: {
    maxWidth: "520px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  screenMask: {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  keyValuePairContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "auto",
    gap: "6px",
  },
  keyText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "16px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    fontWeight: "600",
  },
  valueText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "16px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  walletButton: {
    borderRadius: "0.375rem",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonText,
    textTransform: "capitalize",
    height: "40px",
    width: "150px",
    padding: "8px 16px",
    marginLeft: "15px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonText,
    },
  },
  cancelButton: {
    borderRadius: "14px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    width: "150px",
    padding: "8px 16px",
    marginLeft: "15px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonText,
    },
  },
  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },
  modalTitle: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "25px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    fontWeight: 600,
    marginRight: "auto",

    padding: "8px 24px 0px",
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "19px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },

  priceHeader: {
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "8px",
  },
  priceText: {
    color: theme?.colors?.presale?.addressValueText,
    fontSize: "20px",
    fontWeight: "normal",
    lineHeight: "24px",
    marginBottom: "20px",
    [theme.breakpoints.up("md")]: {
      fontSize: "30px",
      lineHeight: "36px",
      marginBottom: "30px",
    },
  },
  minMaxText: {
    color: theme?.colors?.presale?.commentText,
    fontSize: "19px",
    fontWeight: "normal",
    lineHeight: "24px",
    marginBottom: "16px",
  },
  inputContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: "16px",
  },
  actionContainer: {
    width: "100%",
    display: "flex",
    gap: "16px",
    margin: "16px 0px",
    alignItems: "center",
    justifyContent: "center",
  },
  actionInput: {
    background: "transparent",
    border: "2px solid" + theme?.colors?.createPool?.inputBorder,
    color: theme?.colors?.createPool?.inputLabel,

    width: "100%",
    borderRadius: "20px",
    padding: "16px",
  },
  actionUnderline: {
    color: theme?.colors?.presale.cardTitleSecondary,
  },
  maxButton: {
    position: "absolute",
    right: "16px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    "&:hover": {
      color: theme?.colors?.presale?.cardTitle,
    },
    backgroundColor: "transparent",
    border: "none",
  },
  bnbBalance: {
    fontSize: "15px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    color: theme?.colors?.header?.balanceValue,
  },
});

const BuyModal = ({
  classes,
  closeModal,
  modalOpen,
  tokenPrice,
  minInvestAmount,
  maxInvestAmount,
  presale,
  stakedLockedAmount,
  totalLockedValues,
  fundingToken,
  onBuy,
}) => {
  const [inputValue, setInputValue] = useState(0);
  const [maximumAmount, setMaximumAmount] = useState(0);

  const getGuaranteedAmount = useCallback(() => {
    const currentTimestamp = Date.now() / 1000;
    const openTime = parseInt(presale.openTime);
    const guaEndTime = openTime + parseInt(presale.guaranteedHours);
    const hardcap = parseFloat(
      toFixed(
        bigInt(presale?.hardCapInWei || "0"),
        presale?.fundingTokenDecimals || 18,
        3
      )
    );
    const stakedAmount = parseFloat(
      toFixed(
        bigInt(stakedLockedAmount || "0"),
        presale?.fundingTokenDecimals || 18,
        3
      )
    );
    const lockedAmount = parseFloat(
      toFixed(
        bigInt(totalLockedValues || "0"),
        presale?.fundingTokenDecimals || 18,
        3
      )
    );
    if (guaEndTime > currentTimestamp) {
      return (stakedAmount * hardcap) / lockedAmount;
    }
    return maxInvestAmount;
  }, [maxInvestAmount, presale, stakedLockedAmount, totalLockedValues]);

  useEffect(() => {
    if (presale?.presaleType === "0") {
      setMaximumAmount(maxInvestAmount);
    } else {
      const _maxInvestAmount = parseFloat(
        toFixed(
          bigInt(presale?.maxInvestAmount || "0"),
          presale?.fundingTokenDecimals || 18,
          6
        )
      );
      setMaximumAmount(_maxInvestAmount);
    }
  }, [getGuaranteedAmount, maxInvestAmount, presale]);

  return (
    <Dialog
      open={modalOpen}
      onClose={closeModal}
      fullWidth={true}
      maxWidth={"sm"}
      TransitionComponent={Transition}
      // fullScreen={fullScreen}
      classes={{
        paper: classes.paper,
        paperWidthSm: classes.modalRoot,
        // scrollPaper: classes.screenMask,
      }}
      keepMounted
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <Typography variant="h3" className={classes.modalTitle}>
          Buy Token
        </Typography>

        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={closeModal}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent classes={{ root: classes.root }}>
        <div className={classes.modalContainer}>
          {presale.presaleType === "0" ? (
            <Typography variant="h4" className={classes.minMaxText}>
              Min {minInvestAmount} {fundingToken?.label} and Maximum{" "}
              {maxInvestAmount}&nbsp;
              {fundingToken?.label}
            </Typography>
          ) : (
            <Typography variant="h4" className={classes.minMaxText}>
              Min: {minInvestAmount} {fundingToken?.label} and Max{" "}
              {maximumAmount} {fundingToken?.label}
            </Typography>
          )}

          <div className={classes.inputContainer}>
            <input
              className={classes.actionInput}
              type="text"
              // disableUnderline={true}
              value={inputValue}
              onChange={(ev) => {
                if (/^[0-9.]*$/.test(ev.target.value)) {
                  setInputValue(ev.target.value);
                }
              }}
              // autoFocus={true}
            />
            <button
              className={classes.maxButton}
              onClick={() => {
                setInputValue(maximumAmount.toString());
              }}
            >
              MAX
            </button>
          </div>
          <div className={classes.keyValuePairContainer}>
            <Typography variant="h5" className={classes.keyText}>
              Price:
            </Typography>
            <Typography variant="h3" className={classes.valueText}>
              {tokenPrice} {fundingToken?.label}
            </Typography>
          </div>
          <div className={classes.actionContainer}>
            <OutlineButton
              style={{
                width: "100%",
              }}
              text="Cancel"
              size="md"
              onClick={() => {
                closeModal();
              }}
              aria-hidden="true"
            />
            <Button
              style={{
                width: "100%",
              }}
              onClick={(ev) => {
                if (
                  minInvestAmount <= inputValue &&
                  maximumAmount >= inputValue
                ) {
                  if (onBuy) {
                    onBuy(inputValue);
                  }
                  closeModal();
                } else {
                  setInputValue(minInvestAmount);
                }
              }}
              text="Buy"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default withRouter(withStyles(styles)(BuyModal));
